/**
 * Wishlist sign-up popup.
 * Preserves the Klaviyo wishlist behavior that used to live inline in theme.liquid.
 */
(function () {
  function initWishlistPopup() {
    var popup = document.getElementById('wishlistPopup');
    if (!popup || popup.dataset.wishlistPopupBound === 'true') return;

    popup.dataset.wishlistPopupBound = 'true';

    function openPopup() {
      popup.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function bindWishlistButtons() {
      document.querySelectorAll('.kl-hub-favorites-icon-widget').forEach(function (button) {
        if (button.dataset.popupBound === 'true') return;
        button.dataset.popupBound = 'true';

        button.addEventListener('click', function () {
          var isActive = button.querySelector('.kl-hub-wishlist-icon--active');

          if (!isActive) {
            setTimeout(openPopup, 50);
          }
        }, true);
      });
    }

    bindWishlistButtons();

    var observer = new MutationObserver(bindWishlistButtons);
    observer.observe(document.body, { childList: true, subtree: true });

    popup.addEventListener('click', function (event) {
      if (
        event.target.classList.contains('wishlist-popup-overlay') ||
        event.target.closest('#wishlistClose')
      ) {
        popup.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initWishlistPopup);
  document.addEventListener('shopify:section:load', initWishlistPopup);
})();
